import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

// Import Hub — AI Companion bulk import (subsystem O, paths 1+3).
const ImportHubPage = lazy(() =>
  import('../pages/import-hub/ImportHubPage').then((m) => ({ default: m.ImportHubPage }))
)

export const importHubRoutes: RouteObject[] = [
  {
    path: '/import-hub',
    children: [
      { index: true, element: <ImportHubPage /> },
      { path: ':jobId', element: <ImportHubPage /> },
    ],
  },
]
